import React from "react";
import { Lock, Sparkles, Ticket } from "lucide-react";

import { textoDaFaixa } from "./promocoes";

const juntar = (lista) => {
  const itens = (lista || []).filter(Boolean);
  if (itens.length <= 1) return itens[0] || "seus dados";
  return `${itens.slice(0, -1).join(", ")} e ${itens[itens.length - 1]}`;
};

// Faixa de entrada da Campanha Inteligente no cardápio. Fica no fluxo normal da página, acima
// das categorias: some quando a pessoa rola e só volta no topo. No estado ativo
// ela AVISA e não entrega — tocar não faz nada, a caça é pelo cardápio.
export default function FaixaOfertas({ ofertasDia, darkMode, onEntrar, onCompletarCadastro }) {
  const estado = ofertasDia?.estado;
  if (!["ativo", "anonimo", "bloqueado"].includes(estado)) return null;
  const total = ofertasDia.total || 0;
  if (estado !== "ativo" && total === 0) return null;

  let Icone = Sparkles;
  // Pro cliente o título fala de oferta; "Campanha Inteligente" é o nome da campanha no painel.
  let titulo = "Ofertas exclusivas pra você";
  let texto = textoDaFaixa(ofertasDia);
  let acao = null;
  if (estado === "ativo" && total === 0) {
    Icone = Ticket;
    texto = "Hoje não caiu nenhuma oferta pra você. Volte amanhã.";
  } else if (estado === "bloqueado") {
    Icone = Lock;
    titulo = total === 1 ? "1 oferta exclusiva esperando por você" : `${total} ofertas exclusivas esperando por você`;
    texto = `Adicione ${juntar(ofertasDia.faltando_rotulos)} no seu cadastro para ver.`;
    acao = { rotulo: "Completar cadastro", onClick: onCompletarCadastro };
  } else if (estado === "anonimo") {
    Icone = Lock;
    titulo = "Tem ofertas exclusivas escondidas neste cardápio";
    texto = "Cada cliente tem as suas. Entre para ver as suas.";
    acao = { rotulo: "Entrar", onClick: onEntrar };
  }

  return (
    <div
      className="rounded-2xl border-2 border-primary/50 px-4 py-3 mb-4 flex items-center gap-3"
      style={{ backgroundImage: "linear-gradient(90deg, hsl(var(--primary) / 0.18), hsl(var(--primary) / 0.04))" }}
      data-e2e="faixa-ofertas"
      data-estado={estado}
    >
      <div className="shrink-0 w-10 h-10 rounded-full bg-primary text-primary-foreground flex items-center justify-center">
        <Icone className="w-5 h-5" />
      </div>
      <div className="flex-1 min-w-0">
        <p className={`text-sm font-black leading-tight ${darkMode ? "text-white" : "text-gray-900"}`}>{titulo}</p>
        <p className={`text-xs leading-snug mt-0.5 ${darkMode ? "text-zinc-300" : "text-gray-600"}`}>{texto}</p>
      </div>
      {acao && acao.onClick ? (
        <button
          type="button"
          onClick={acao.onClick}
          className="shrink-0 rounded-full bg-primary text-primary-foreground text-xs font-bold px-3 h-8 active:scale-95 transition"
          data-e2e="faixa-ofertas-acao"
        >
          {acao.rotulo}
        </button>
      ) : null}
    </div>
  );
}
